import { useEffect } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { pageMeta } from '~/lib/site/seo'
import { cacheHeaders } from '~/lib/site/cache'
import { GivingInfoPage } from '~/components/sections/GivingInfoPage'
import { loadDoubleTheDonation } from '~/lib/browser/loadScript'

export const Route = createFileRoute('/employer-donation-matching')({
  headers: () => cacheHeaders.content,
  head: () =>
    pageMeta({
      title: 'Matching Gifts',
      description:
        'Multiply the impact of your donation. Search whether your employer matches donations to Friends of DxE.',
      ogDescription: 'Multiply the impact of your donation.',
    }),
  component: EmployerMatching,
})

function EmployerMatching() {
  useEffect(() => {
    void loadDoubleTheDonation('search')
  }, [])

  return (
    <GivingInfoPage
      title="Matching Gifts"
      subtitle="Multiply the impact of your donation"
    >
      <p className="mb-6 text-lg leading-[26px]">
        Thank you so much for donating to Friends of DxE! Thousands of companies
        match their employees’ donations to organizations like ours as a way to
        show their appreciation. Please use the below search tool to see if your
        company is on the list and to access the forms, guidelines, and
        instructions that you need to submit a matching gift.
      </p>
      <div id="dd-container" className="text-base">
        <a
          href="https://doublethedonation.com/matching-grant-resources/matching-gift-basics/"
          className="text-accent underline"
        >
          Matching Gift
        </a>{' '}
        and{' '}
        <a
          href="https://doublethedonation.com/matching-grant-resources/volunteer-grant-basics/"
          className="text-accent underline"
        >
          Volunteer Grant
        </a>{' '}
        information provided by <br />
        <a href="https://doublethedonation.com">
          <img
            alt="Powered by Double the Donation"
            src="https://doublethedonation.com/api/img/powered-by.png"
          />
        </a>
      </div>
    </GivingInfoPage>
  )
}
